export default "__VITE_ASSET__wL8zAC50__"